import qs from 'qs';
import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {SearchThemeKeywordParam} from '../../common/shared/api/nicolas/params/SearchThemeKeywordParam.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {CategoryTypeVo} from '../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import type {SearchThemeKeywordResultVo} from '../../common/shared/api/nicolas/vo/SearchThemeKeywordResultVo.interface';

/**
 * 테마 검색 키워드 결과 조회
 *
 * Origin: pageNicolasApi.getSearchThemeKeyword
 * API: GET /api/v1/search/filter
 */
export async function getSearchFilter(
  {
    filterList,
    categoryUid: _categoryUid,
    page: _page,
    size: _size,
    sortType,
  }: SearchThemeKeywordParam,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: SearchThemeKeywordResultVo}> {
  // 원본 PageNicolasApi와 동일한 기본값 처리
  const page = _page || 0;
  const size = _size || 25;
  const categoryUid = _categoryUid || CategoryTypeVo.None;

  const response = await axiosBffFetch(
    '/api/gateway/api/v1/search/filter',
    {
      method: 'GET',
      params: {
        filter_list: filterList,
        category_uid: categoryUid,
        page,
        size,
        ...(sortType && {sort_type: sortType}),
      },
      paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'}),
    },
    options
  );
  return response.data;
}
